export default function isMobileDevice() {
    return window.matchMedia('only screen and (max-width: 1024px)').matches;
  }